import React from "react";
import { chakra } from "@chakra-ui/react";
import { WithClassName } from "@/types/base";
import { observer } from "mobx-react-lite";
import { useTranslate } from "@/utils/lang";
import { User_Assets_Words } from "@/utils/lang/userAsset";
import { isNotVipAuthUser } from "@/utils/status";

type GenerateCostTextProps = WithClassName<{
  cost: number;
  show?: boolean;
}>;
const _GenerateCostText: React.FC<GenerateCostTextProps> = ({
  cost,
  className,
  show = isNotVipAuthUser(),
}) => {
  const { translate } = useTranslate();

  if (!show) return null;
  return (
    <chakra.span className={className} display="inline-flex" alignItems="center">
      <chakra.span mx="8px" mt="-2px">
        |
      </chakra.span>
      <chakra.span
        fontSize="16px"
        display="inline-block"
        whiteSpace="nowrap"
        fontWeight={400}
        transform="scale(0.625)"
        transformOrigin="left"
      >
        {translate(User_Assets_Words.cost)} {cost} ⭐
      </chakra.span>
    </chakra.span>
  );
};

export const GenerateCostText = chakra(observer(_GenerateCostText));
